
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";


export default function CreateSchema({ schemaLoader, setAddingSchema, noFunds, setError}) {
    
    return(
        <Button
            onClick={noFunds ? () => setError("You must add funds to a funding pool before you can create a schema.") : () => setAddingSchema(true)}
            sx={{
                display: schemaLoader ? "none" : "flex",
                color: "#118EA0",
                textTransform: "none",
                justifyContent: "left",
                fontWeight: "bold",
                fontSize: "18px",
                lineHeight: "21px",
                backgroundColor: "transparent",
                width: "100%",
                flexDirection: "row",
                fontFamily: "Averta",
                fontSize: "18px",
                lineHeight: "21px",
                "& .MuiButton-endIcon": {
                    marginLeft: "auto"
                },
                "&:hover" : {color: "#fff"}
            }}
            endIcon={<AddIcon />}
        >
            Create Schema
        </Button>
    )
}